import { apiSlice } from "../apiSlice";

const pickupApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getPickupRequestList: builder.query({
            query: (id) => {
                return {
                    url: `/api/pickup-request/list?merchant_id=${id}`,
                    method: 'GET',
                }
            },
            providesTags: ['pickupRequest']
        }),
        createPickupRequest: builder.mutation({
            query: (body) => {
                return {
                    url: `/api/pickup-request/create`,
                    method: 'POST',
                    body
                }
            },
            invalidatesTags: ['pickupRequest']
        }),
    }),
    overrideExisting: true,
});

export const { useGetPickupRequestListQuery, useCreatePickupRequestMutation } = pickupApiSlice;
